// extracted by mini-css-extract-plugin
export default {"skills_container":"Skills_skills_container__h+5jm","skills_image":"Skills_skills_image__eYn6S"};